import { useState, useEffect, useCallback, useMemo } from 'react';
import { PluginConfig } from '../models/plugin-config';
import { fetchFonts } from '../services/css-service';

export function useFonts(config: PluginConfig | null) {
    const [fonts, setFonts] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>(null);

    const fontStyles = useMemo((): string | null => {
        if (!fonts?.length) return null;

        return fonts.map((font: any) => {
            const variableDeclarations = font.fontVariables
                .map((variable: any) => `\n--${variable}: ${font.fontFamily};`)
                .join('');

            return `${font.fontFance} html body #simplex-club-plugin {${variableDeclarations}}`;
        }).join('\n');
    }, [fonts]);

    const loadFonts = useCallback(async (): Promise<void> => {
        if (!config || isLoading) return;

        setIsLoading(true);
        setError(null);

        try {
            const response = await fetchFonts(config.chainId, config.language);
            if (response) {
                setFonts(response);
            }
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [config, isLoading]);

    useEffect(() => {
        loadFonts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config]);

    useEffect(() => {
        if (fontStyles) {
            const styleTag = document.createElement("style");
            styleTag.textContent = `${fontStyles}`;
            document.head.appendChild(styleTag);
            return () => {
                styleTag.remove();
            };
        }
    }, [fontStyles]);

    return {
        fonts,
        isLoadingFonts: isLoading,
        error,
        fontStyles,
    };
}
